import { createFileRoute } from "@tanstack/react-router";

import { CoachAthleteQuestionnairesPage } from "src/pages/CoachAthleteQuestionnairesPage";
import { createPrivateQuestionnairesRepository } from "src/repositories/questionnaires/createPrivateQuestionnairesRepository";
export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/",
)({
  component: CoachAthleteQuestionnairesPage,
  ssr: true,
  async loader({ context, params }) {
    await context.queryClient.query({
      ...createPrivateQuestionnairesRepository().listOptions(params.athleteId, {
        pageIndex: 0,
        pageSize: 20,
      }),
      staleTime: "static",
    });
  },
});
